const info = {
  ZH: { //中文翻译
    mustSelect: "\u8BF7\u5148\u9009\u62E9\u4E00\u4E2A\u67E5\u8BE2\u7ED3\u679C",
    correctPage: "\u8BF7\u8F93\u5165\u6B63\u786E\u9875\u7801",
    searchMds: "\u5F15\u7528\u8868\u5355\u5206\u6790",
    result: "MDS\u67E5\u8BE2\u7ED3\u679C",
    search: "\u8868\u5355\u5206\u6790",
    accord: '\u6309\u7167 "\u8868\u5355\u7C7B\u578B"\u5206\u7C7B(\u96F6\u90E8\u4EF6-\u534A\u6210\u54C1-\u6750\u6599) - \u540C\u65F6"\u521B\u5EFA\u65F6\u95F4"\u5012\u5E8F\u6392\u5217',
    asName: "\u540D\u79F0",
    asNumber: "\u6761\u76EE\u53F7",
    asSupply: "\u4F9B\u5E94\u5546",
    asCreateTime: "\u521B\u5EFA\u65F6\u95F4",
    desc: "\u964D\u5E8F",
    asc: "\u5347\u5E8F",
    order: "\u6392\u5E8F",
    checkout: "\u67E5\u770B",
    modify: "\u4FEE\u6539",
    copy: "\u590D\u5236",
    delete: "\u5220\u9664",
    favorite: "\u6536\u85CF",
    preview: "\u9884\u89C8",
    analyze: "\u5206\u6790",
    newSearch: "\u65B0\u7684\u67E5\u627E",
    index: "\u5E8F\u53F7",
    proName: "\u4EA7\u54C1\u540D\u79F0",
    CproName: "\u4F9B\u8D27\u540D\u79F0",
    proNameForMaterial: "\u540D\u79F0\uFF0C>\u6750\u6599\u6807\u8BC6<",
    CproNameForMaterial: "\u4F9B\u8D27\u540D\u79F0,>\u6750\u6599\u6807\u8BC6<",
    longDes: "\u96F6\u90E8\u4EF6\u53F7,\u534A\u6210\u54C1\u4EF6\u53F7,\u6750\u6599\u53F7",
    ClongDes: "\u4F9B\u8D27\u7F16\u53F7",
    shortDes: "\u96F6\u90E8\u4EF6\u53F7,\u534A...",
    refstandard: "\u5F15\u7528\u6807\u51C6",
    version: "\u7248\u672C",
    finded: "\u67E5\u8BE2\u5230",
    count: "\u6761",
    show: "\u663E\u793A",
    page: "\u9875",
    downLoad: "\u4E0B\u8F7D",
    downLoadImds: "Imds\u4E0B\u8F7D",
    noneSelect: "\u6CA1\u6709\u53EF\u4F9B\u4E0B\u8F7D\u7684MDS",
    Selected: "\u9009\u62E9\u7684\u6750\u6599\u6570\u636E\u8868\u5171\u8BA1\uFF1A",
    maxCount: "\u6BCF\u6B21\u6700\u591A\u4E0B\u8F7D50\u6761\u8BB0\u5F55\uFF01",
    maskLayer: "\u6B63\u5728\u5904\u7406\u6570\u636E\uFF0C\u8BF7\u7A0D\u5019...",
    complianceinfo: "\u627F\u8BFA\u4E66",
    deleteAlert: "\u5DF2\u88AB\u4E0B\u8F7D\uFF0C\u4E0D\u80FD\u5220\u9664",
    overdue: "\u6807\u8BB0\u4E3A\u8FC7\u671F",
    overdeMsg: "\u6807\u8BB0\u4E3A\u8FC7\u671F\u7684\u6570\u636E\u8868\uFF0C\u4E0D\u5EFA\u8BAE\u53D1\u9001\u3001\u63D0\u4EA4\u6216\u5F15\u7528",
    effective: "\u6807\u8BB0\u4E3A\u6709\u6548",
    effectiveMsg: "\u6807\u8BB0\u4E3A\u6709\u6548",
    reach: "REACH\u62A5\u8868 ",
    imdsSelect: "\u8D85\u8FC710\u6761\u6570\u636E\uFF0C\u5F71\u54CD\u4E0A\u4F20\u4E0B\u8F7D\u6548\u7387\uFF0C\u5EFA\u8BAE10\u6761\u6570\u636E\u4EE5\u5185\uFF01",
    mdsType: " \u8868\u5355\u7C7B\u578B",
    lock: "\u9501\u5B9A",
    lockmsg: "\u9501\u5B9A\u8868\u5355\uFF0C\u5176\u4ED6\u7528\u6237\u4E0D\u53EF\u4FEE\u6539\u3001\u5220\u9664\u3001\u6807\u8BB0\u8FC7\u671F",
    unlock: "\u89E3\u9501",
    unlockmsg: "\u89E3\u9501\u8868\u5355",
    checkVehcleMsg: " \u8be5\u96f6\u90e8\u4ef6\u662f\u8f66\u578b\u96f6\u90e8\u4ef6\uff0c\u8bf7\u5148\u5220\u9664\u8f66\u578b",
    mdsSetSuccess:"MDS设置成功！",
    denialReason:"拒绝理由",
  },
  EN: { //英文翻译
    mustSelect: "Please select a query result first!",
    correctPage: "Please input the correct Page No.",
    searchMds: "Ref MDS Analyse",
    result: "MDS Search results",
    search: "MDS Analyse",
    accord: "Sort by form type (component-semi-material) - and arrange in reverse order of creation time",
    asName: "Name",
    asNumber: "Item No.",
    asSupply: "Supplier",
    asCreateTime: "Creation date",
    desc: "Descending",
    refstandard: "Reference Standard",
    asc: "Ascending",
    order: "Order",
    checkout: "View",
    modify: "Modify",
    copy: "Copy",
    delete: "Delete",
    favorite: "Folder",
    preview: "Preview",
    analyze: "Analyze",
    newSearch: "New Search",
    index: "No.",
    proName: "Article Name",
    CproName: "Designated Name by customer",
    proNameForMaterial: "MdsName,>Material Symbol<",
    CproNameForMaterial: "designated Name by customer,>Material Symbol<",
    longDes: "Part/Item No., Item- /Mat.-No., Material No.",
    ClongDes: "Designated Component No. by customer",
    shortDes: "Part/Item No...",
    version: "Version",
    finded: "Search for",
    count: "Item(s)",
    show: "Display",
    page: "Pages",
    downLoad: "DownLoad",
    downLoadImds: "IMDS DownLoad",
    noneSelect: "No MDS Available For Download",
    Selected: "Choosing items\uFF1A",
    maxCount: "The max download item is 50 every time\uFF01",
    maskLayer: "Data is being processed, please wait ...",
    complianceinfo: "Commitment",
    deleteAlert: "Data has been downloaded, cannot delete",
    overdue: "Mark as obsolete",
    overdeMsg: "The MDS marked as obsolete would not be allowed for future submissions anymore.",
    effective: "Mark as valid",
    effectiveMsg: "Mark as valid",
    reach: "REACH Report",
    imdsSelect: "More than 10 MDSs are selected, it will affect the efficiency when uploading and downloading. We suggest you to choose less than 10 MDSs at a time!",
    mdsType: "Mds Type",
    lock: " lock",
    unlock: "unlock",
    lockmsg: " MDS is locked",
    lockmsg: "MDS will be locked.",
    checkVehcleMsg: " This part is a model part, please delete the model first ",
    denialReason:"Refusal Reason",
  }
}
export default info //需要暴露出去
